export const SELECT_VERBATIM = 'SELECT_VERBATIM';

export const selectVerbatim = verbatim => ({
  type: SELECT_VERBATIM,
  data: verbatim,
});
